import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-email-changed',
  templateUrl: './email-changed.component.html',
  styleUrls: ['./email-changed.component.scss']
})
export class EmailChangedComponent {

  constructor(private router: Router) { }

  redirectNow(): void {
    this.router.navigate(['']);
  }
}
